import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
  styles: [`
  >>> app-price {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
`]
})
export class PriceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
